import React from 'react';
import { useSelector } from 'react-redux';
import L from 'leaflet';
import {markersInfoState, RegionMarkersInfoState} from '../../../../../app/redux/retrievers/retrievers';
import { sendDataToParent } from '../../../base/functions/sendDataToParent';
import { icon } from '../../../configs/map-icon.config';
import ClusterGenerator from '../../../../common/ClusterGenerator/ClusterGenerator';

const RegionMarkerCluster = () => {
    const markersInfo = useSelector(RegionMarkersInfoState);

    return markersInfo ? (
        <ClusterGenerator
            coordinates={markersInfo}
            filterFunction={(marker: any) => marker.latitude && marker.longitude}
            mapFunction={(marker: any) =>
                L.marker([marker.latitude, marker.longitude], { icon: icon() }).on('click', () => {
                    sendDataToParent({ type: 'marker-clicked', clientMarkerId: marker.clientMarkerId });
                })
            }
            clusterOptions={{
                // maxClusterRadius: 15,
                // chunkedLoading: true,
                disableClusteringAtZoom: 16,
                removeOutsideViewport: true,
                spiderfyOnMaxZoom: false,
            }}
        />
    ) : null;
};

export default RegionMarkerCluster;
